export default function normalizeTargetOrigin(targetOrigin: string) {
  return targetOrigin === 'null' ? '*' : targetOrigin;
}
